export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Logo EDL-EXPRESS">
    <circle cx="27" cy="27" r="21" fill="#0B1222" stroke="#22D3EE" strokeOpacity="0.35" strokeWidth="2" />
    <circle cx="27" cy="27" r="16.5" fill="#EDF2FC" stroke="#1B3A6B" strokeWidth="4" />
    <path d="M19 27.5 27 19.5l8 7.7" fill="none" stroke="#1B3A6B" strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="21.2" y="27" width="11.6" height="9.6" fill="none" stroke="#1B3A6B" strokeWidth="3.6" strokeLinejoin="round" />
    <path d="M24.2 32l2.7 2.7 5.4-5.9" fill="none" stroke="#22D3EE" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="41.5" y1="41.5" x2="50" y2="50" stroke="#22D3EE" strokeWidth="7" strokeLinecap="round" />
  </svg>
);

export default function Logo({ className = "" }) {
  return (
    <img
      src="/logo.webp"
      alt="EDL-EXPRESS — États des lieux immobiliers"
      className={`h-9 w-auto md:h-10 ${className}`}
    />
  );
}
